export enum AssetsTransferEnum {
    DriverDetails = 1,
    Assets = 2,
    DriverSignature = 3
}